exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select .ng-star-inserted:disabled {\n  background: #dddddd;\n  color: #6C6C6C; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/guest-form/guest-form.component.scss
// module id = ../../../../../src/app/check-out/guest-form/guest-form.component.scss
// module chunks = main